import { useEffect, useLayoutEffect, useState } from "react";
import { gsap } from "animations/gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useGsapContext } from "animations";
import styles from "components/ImageNavigation/ImageNavigation.module.scss";

function useOperationsManagementAnimations(el: any, setOffset: Function) {
  const ctx = useGsapContext(el);

  useLayoutEffect(() => {
    ctx.add(() => {
      // fade page in
      gsap.to(el.current, {
        opacity: 1,
        duration: 1,
        delay: 0.5,
      });

      // Banner animation
      const banner_tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".anim-banner",
          start: "top 75%",
        },
      });
      banner_tl.current && banner_tl.current.progress(0).kill();

      banner_tl
        .from(".anim-banner-title", { opacity: 0, xPercent: -100, duration: 1 })
        .from(
          ".anim-banner-subtitle",
          {
            opacity: 0,
            xPercent: 100,
            duration: 1,
          },
          "<"
        );

      // Quote animation
      const quote_tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".anim-quote",
          start: "top 85%",
        },
      });
      quote_tl.current && quote_tl.current.progress(0).kill();

      quote_tl
        .fromTo(
          ".anim-quote-content",
          { opacity: 0, xPercent: -100 },
          {
            opacity: 1,
            xPercent: -0,
            duration: 0.9,
          }
        )
        .fromTo(
          ".anim-quote-img",
          { opacity: 0, xPercent: 100 },
          { opacity: 1, xPercent: 0, duration: 0.9 },
          "<=-0.1"
        );

      // Navigation animation
      const nav_tl = gsap.timeline({
        stagger: 1,
        scrollTrigger: {
          trigger: ".anim-navigation",
          start: "top center",
        },
      });
      nav_tl.current && nav_tl.current.progress(0).kill();
      gsap.utils
        .toArray(".anim-nav-link")
        .forEach(function (link: any, i: number) {
          const toggleClass = (el: any) => {
            el.classList.toggle(styles["anim-active"]);
          };
          nav_tl
            .call(toggleClass, [link], 0.25 * i)
            .call(toggleClass, [link], 0.25 * i + 0.25);
        });
    });

    return () => ctx.revert();
  }, []);

  useLayoutEffect(() => {
    const _setOffset = () => {
        const lottieEl = document.getElementById("lottie");
        setOffset(
          Math.ceil(lottieEl!.getBoundingClientRect().top + window.scrollY)
        );
      },
      resizeWin = (e: any) => {
        e.preventDefault();
        gsap.to(window, { duration: 0, scrollTo: 0 });
        _setOffset();
        ScrollTrigger.sort();
        ScrollTrigger.refresh();
      };

    _setOffset();
    gsap.to(window, { duration: 0, scrollTo: 0 });
    window.addEventListener("resize", resizeWin);

    return () => {
      window.removeEventListener("resize", resizeWin);
    };
  }, []);
}
export default useOperationsManagementAnimations;
